import en from './en'
import vi from './vi'

import _ from 'lodash'

_.templateSettings.interpolate = /{{([\s\S]+?)}}/g

const translate = (locale) => (key, options = {}) => {
  key = key.replace(':', '.')
  switch (locale) {
    case 'en':
      return _.template(_.get(en, key))(options)
    case 'vi':
      return _.template(_.get(vi, key))(options)
    default:
      return _.template(_.get(en, key))(options)
  }
}

export default translate
